import { portfolioRoutePaths } from './paths';

import type { RouteObject } from 'react-router-dom';

export const portfolioRoute: RouteObject = {
  path: portfolioRoutePaths.portfolio.path,
  async lazy() {
    const PortfolioPage = await import('@/pages/portfolio/PortfolioPage');
    return { Component: PortfolioPage.default };
  },
};
